import { ukI15SearchApiURL } from '../../Environment/Variables';

export const getSearchUrl = () => {
  return ukI15SearchApiURL || 'https://api.uk.prod.group-mobility-trader.com';
};
